import AccountFrozenModalContent from './AccountFrozenModalContent';

export default AccountFrozenModalContent;
